import {
  CREATE_QUOTE_START,
  CREATE_QUOTE_SUCCESS,
  CREATE_QUOTE_FAIL,

  GET_QUOTES_START,
  GET_QUOTES_SUCCESS,
  GET_QUOTES_FAIL,

  GET_QUOTE_START,
  GET_QUOTE_SUCCESS,
  GET_QUOTE_FAIL,

  UPDATE_QUOTE_START,
  UPDATE_QUOTE_SUCCESS,
  UPDATE_QUOTE_FAIL,

  CHANGE_QUOTE_STATUS_START,
  CHANGE_QUOTE_STATUS_SUCCESS,
  CHANGE_QUOTE_STATUS_FAIL,

  GENERATE_QUOTE_PDF_START,
  GENERATE_QUOTE_PDF_SUCCESS,
  GENERATE_QUOTE_PDF_FAIL,
} from "./constant";

const INITIAL_STATE = {

  loading: false,

  quotes: [],

  quote: null,

  pdf: null,

  total_records: 0,

  total_pages: 0,

  current_page: 1,

  success: "",

  error: "",

};

const QuoteReducer = (state = INITIAL_STATE, action) => {

  switch (action.type) {

    // =========================
    // Create Quote
    // =========================

    case CREATE_QUOTE_START:
      return {
        ...state,
        loading: true,
        success: "",
        error: "",
      };

    case CREATE_QUOTE_SUCCESS:
      return {
        ...state,
        loading: false,
        success: action.payload.message,
      };

    case CREATE_QUOTE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // =========================
    // Get Quotes
    // =========================

    case GET_QUOTES_START:
      return {
        ...state,
        loading: true,
      };

    case GET_QUOTES_SUCCESS:
      return {
        ...state,
        loading: false,
        quotes: action.payload.data,
        total_records: action.payload.total_records,
        total_pages: action.payload.total_pages,
        current_page: action.payload.current_page,
      };

    case GET_QUOTES_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // =========================
    // View Quote
    // =========================

    case GET_QUOTE_START:
      return {
        ...state,
        loading: true,
      };

    case GET_QUOTE_SUCCESS:
      return {
        ...state,
        loading: false,
        quote: action.payload.data,
      };

    case GET_QUOTE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // =========================
    // Update Quote
    // =========================

    case UPDATE_QUOTE_START:
      return {
        ...state,
        loading: true,
      };

    case UPDATE_QUOTE_SUCCESS:
      return {
        ...state,
        loading: false,
        success: action.payload.message,
      };

    case UPDATE_QUOTE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // =========================
    // Change Quote Status
    // =========================

    case CHANGE_QUOTE_STATUS_START:
      return {
        ...state,
        loading: true,
      };

    case CHANGE_QUOTE_STATUS_SUCCESS:
      return {
        ...state,
        loading: false,
        success: action.payload.message,
      };

    case CHANGE_QUOTE_STATUS_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // =========================
    // Generate Quote PDF
    // =========================

    case GENERATE_QUOTE_PDF_START:
      return {
        ...state,
        loading: true,
      };

    case GENERATE_QUOTE_PDF_SUCCESS:
      return {
        ...state,
        loading: false,
        pdf: action.payload.data,
      };

    case GENERATE_QUOTE_PDF_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };


    default:
      return state;
  }

};

export default QuoteReducer;